export default "__VITE_ASSET__b4538f03__"